
function HistorySVG() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1921_74075)">
        <path d="M11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V10.41L9.71 13.7C9.31 14.08 8.68 14.07 8.3 13.68C7.93 13.29 7.93 12.68 8.3 12.29L11.01 9.58V5H11ZM12 0C17.51 0 22 4.49 22 10C22 15.51 17.51 20 12 20C9.54 20 7.17 19.1 5.33 17.45C4.92 17.09 4.87 16.45 5.24 16.04C5.6 15.63 6.24 15.58 6.65 15.95C6.65 15.95 6.65 15.95 6.66 15.96C8.13 17.27 10.03 18 11.99 18C16.4 18 19.99 14.41 19.99 10C19.99 5.59 16.41 2 12 2C7.93 2 4.56 5.06 4.07 9H6L3 12L0 9H2.05C2.55 3.95 6.82 0 12 0Z" fill="#A0A0A0"/>
      </g>
      <defs>
        <clipPath id="clip0_1921_74075">
          <rect width="22" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export { HistorySVG }